import React, { useRef, useState } from 'react';
import './SymbolSearch.css';

export const normalizeSymbol = text => String(text).normalize('NFKC').replace(/ي|ى/g, 'ی').replace(/ك/g, 'ک')
  .replace(/[۰-۹]/g, c => String(c.charCodeAt(0)-1776)).replace(/[٠-٩]/g, c => String(c.charCodeAt(0)-1632))
  .replace(/[\s\u200c\u200d]/g, '').toLowerCase();

export default function SymbolSearch({ id, symbols, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [active, setActive] = useState(0);
  const input = useRef(null);
  const options = [{ value: 'ALL', label: 'همه نمادها' }, ...symbols.map(symbol => ({ value: symbol, label: symbol }))]
    .filter(option => normalizeSymbol(option.label).includes(normalizeSymbol(query)));
  const index = Math.min(active, Math.max(0, options.length-1));
  const choose = option => { onChange(option.value); setOpen(false); setQuery(''); };
  const keyDown = event => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!open) { setOpen(true); setQuery(''); setActive(0); }
      else if (options.length) setActive((index+(event.key === 'ArrowDown' ? 1 : -1)+options.length)%options.length);
    } else if (event.key === 'Enter' && open) {
      event.preventDefault(); if (options[index]) choose(options[index]);
    } else if (event.key === 'Escape') { setOpen(false); setQuery(''); }
  };
  return <div className="symbol-search" onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) { setOpen(false); setQuery(''); } }}>
    <div className="symbol-search-field">
      <input ref={input} id={id} type="text" role="combobox" autoComplete="off" aria-autocomplete="list"
        aria-expanded={open} aria-controls={`${id}-options`} aria-activedescendant={open && options[index] ? `${id}-option-${index}` : undefined}
        value={open ? query : value === 'ALL' ? 'همه نمادها' : value} placeholder="نام یا شماره نماد را جستجو کنید…"
        onFocus={() => { setOpen(true); setQuery(''); setActive(0); }}
        onClick={() => { if (!open) { setOpen(true); setQuery(''); setActive(0); } }}
        onChange={event => { setQuery(event.target.value); setOpen(true); setActive(0); }} onKeyDown={keyDown} />
      {value !== 'ALL' && <button type="button" className="symbol-search-clear" aria-label="پاک کردن نماد" onClick={() => choose({ value: 'ALL' })}>×</button>}
    </div>
    {open && <div id={`${id}-options`} role="listbox" aria-label="نتایج جستجوی نماد" className="symbol-search-options">
      {options.length ? options.map((option, i) => <button type="button" role="option" tabIndex={-1} id={`${id}-option-${i}`} key={option.value}
        aria-selected={option.value === value} className={i === index ? 'is-active' : ''}
        onMouseDown={event => event.preventDefault()} onMouseEnter={() => setActive(i)} onClick={() => choose(option)}>{option.label}</button>)
        : <div className="symbol-search-empty" role="status">نمادی پیدا نشد</div>}
    </div>}
  </div>;
}
